export default defineNuxtRouteMiddleware((to, from) => {
  if (!process.server) {
    return;
  }

  const name = (to.name as string)?.split('___')[0];
  const locale = (to.name as string)?.split('___')[1];

  if (name === 'proxy') {
    return navigateTo(`/${locale}/proxy/resident`)
  }
});